import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Leaderboard from "../components/Home/LeaderBoard";
import Loader from "../components/Utils/Loader";
import PageContainer from "./PageContainer";
import "../assets/ratings.css";
import { Box, Button } from "@mui/material";

const RatingsFull = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [leaderboardData, setLeaderboardData] = useState([]);
  const type = searchParams.get("type") || "overall";

  const typeToTitle = {
    points: "Points Leaders",
    rebounds: "Rebound Ratings",
    assists: "Assist Ratings",
    overall: "Overall Ratings",
    defense: "Defensive Ratings",
    playmaking: "Playmaking Ratings",
    ball_handling: "Ball Handling Ratings",
  };

  const handleTypeChange = (newType) => {
    navigate(`/leaderboard?type=${newType}`);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .post(
        "/api/players/single-leaderboard",
        { type },
        { withCredentials: true }
      )
      .then((response) => {
        setLeaderboardData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Failed to load leaderboard data");
        console.error("Error fetching leaderboard:", error);
      });
  }, [type]);

  if (loading) {
    return <Loader />;
  }

  return (
    <PageContainer>
      <div className="ratings-full-container">
        <h1 className="ratings-full-title">{typeToTitle[type]}</h1>
        <Box className="ratings-full-nav">
          {Object.keys(typeToTitle).map((leaderboardType) => (
            <Button
              key={leaderboardType}
              variant={type === leaderboardType ? "contained" : "outlined"}
              color="primary"
              onClick={() => handleTypeChange(leaderboardType)}
              className={`ratings-full-nav-button ${
                type === leaderboardType ? "active" : ""
              }`}
            >
              {typeToTitle[leaderboardType]}
            </Button>
          ))}
        </Box>
        <div className="ratings-full-leaderboard">
          <Leaderboard data={leaderboardData} type={type} />
        </div>
      </div>
    </PageContainer>
  );
};

export default RatingsFull;
